export default "__VITE_ASSET__KwPTn$IZ__"